import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/app/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
// Copyright 2017-2022 @polkadot/types-codec authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { Text } from "../native/Text.js";
import { sanitize } from "../utils/index.js";
/**
 * @name Type
 * @description
 * This is a extended version of Text, specifically to handle types. Here we rely fully
 * on what Text provides us, however we also adjust the types received from the runtime,
 * i.e. we remove the `T::` prefixes found in some types for consistency across implementation.
 */

export var Type = /*#__PURE__*/function (_Text) {
  _inherits(Type, _Text);

  var _super = _createSuper(Type);

  function Type(registry) {
    var _this;

    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    _classCallCheck(this, Type);

    _this = _super.call(this, registry, value);

    _this.setOverride(sanitize(_this.toString()));

    return _this;
  }
  /**
   * @description Returns the base runtime type name for this instance
   */


  _createClass(Type, [{
    key: "toRawType",
    value: function toRawType() {
      return 'Type';
    }
  }]);

  return Type;
}(Text);